export default {
  site: {
    name: 'CSSSpreadsheetBR',
    tagline: 'Independent CSSBuy Resource',
    description: 'Find and organize CSSBuy Spreadsheet resources in one place. Explore product links, categories, buying guides, QC, warehouse, international shipping and useful information to research better before buying.',
    title: 'CSSBuy Spreadsheet: Find Products, Links & CSSBuy Guides',
    metaDesc: 'CSSBuy Spreadsheet: independent guide with product links, categories, reviews, shipping, warehouse, coupons and safety tips. Research resource before you buy.',
  },
  nav: {
    home: 'Home',
    shoppingGuide: 'Shopping Guide',
    spreadsheet: 'CSSBuy Spreadsheet',
    review: 'CSSBuy Review',
    shipping: 'Shipping',
    coupon: 'Coupon',
    warehouse: 'Warehouse',
    legit: 'Is It Safe?',
    guides: 'Guides',
    articles: 'Articles',
    about: 'About',
    contact: 'Contact',
    privacy: 'Privacy',
    terms: 'Terms',
  },
  hero: {
    eyebrow: 'CSSBuy Spreadsheet • Independent Guide',
    h1: 'CSSBuy Spreadsheet: Find Products, Links & CSSBuy Guides',
    description: 'Find and organize CSSBuy Spreadsheet resources in one place. Explore product links, categories, buying guides, QC, warehouse, international shipping and useful information to research better before buying.',
    ctaPrimary: 'Explore CSSBuy Spreadsheet',
    ctaSecondary: 'View CSSBuy Guides',
    searchPlaceholder: 'Search products, categories or CSSBuy Spreadsheet...',
    trust: 'Independent resource • English content • Updated guides • Safety focused',
    ctaMainSite: 'CSSBuy Spreadsheet',
    ctaBuyNow: 'Buy It Now',
  },
  categories: {
    title: 'Popular Categories',
    subtitle: 'Find the best products by category on the CSSBuy Spreadsheet',
    shoes: 'Shoes',
    hoodies: 'Hoodies/Sweaters',
    tshirts: 'T-Shirts',
    jackets: 'Jackets',
    pants: 'Pants/Shorts',
    headwear: 'Headwear',
    sets: 'Sets',
    underwear: 'Underwear/Underpants',
    jersey: 'Jersey',
    accessories: 'Accessories',
    bags: 'Bags',
    belts: 'Belts',
    perfumes: 'Perfumes',
    other: 'Other Stuff',
    dropdownLabel: 'All Categories',
  },
  valueProposition: {
    h2: 'Everything you need to explore the CSSBuy Spreadsheet',
    spreadsheet: 'CSSBuy Spreadsheet',
    spreadsheetDesc: 'Products, links and categories organized to make your research easier before buying.',
    guides: 'CSSBuy Guides',
    guidesDesc: 'Buying guides, QC, warehouse and shipping so you can buy safely.',
    review: 'CSSBuy Review',
    reviewDesc: 'Independent information and analysis about the buying process and agents.',
    safety: 'Safety',
    safetyDesc: 'How to verify links, sellers, products and costs before buying.',
  },
  howItWorks: {
    h2: 'How to use the CSSBuy Spreadsheet?',
    step1: 'Search',
    step1Desc: 'Find products and categories in the CSSBuy Spreadsheet',
    step2: 'Verify',
    step2Desc: 'Check links, seller, product and QC before buying',
    step3: 'Compare',
    step3Desc: 'Analyze options, costs and information to make the best decision',
    cta: 'Explore CSSBuy Spreadsheet',
  },
  comparison: {
    h2: 'Comparison: What to Check Before Buying',
    factor: 'Factor',
    whatToCheck: 'What to Check',
    product: 'Product',
    productCheck: 'Link, seller and product information',
    qc: 'QC',
    qcCheck: 'Available inspection information',
    warehouse: 'Warehouse',
    warehouseCheck: 'Storage and handling',
    shipping: 'Shipping',
    shippingCheck: 'Current options and costs',
    coupon: 'Coupon',
    couponCheck: 'Expiration and eligibility',
    safety: 'Safety',
    safetyCheck: 'Verification before payment',
  },
  commercialCards: {
    h2: 'Most Searched CSSBuy Resources',
    review: 'CSSBuy Review',
    reviewDesc: 'Independent evaluation of process, costs and reliability.',
    shipping: 'CSSBuy Shipping Cost',
    shippingDesc: 'Understand weight, dimensions, destination, shipping lines and consolidation.',
    coupon: 'CSSBuy Coupon',
    couponDesc: 'How to find and verify coupons and discount codes.',
    warehouse: 'CSSBuy Warehouse',
    warehouseDesc: 'Order → Seller → Warehouse → QC → Storage → Consolidation → Shipping.',
    legit: 'CSSBuy Legit',
    legitDesc: 'Evaluate information, payments, support, warehouse and security.',
    cta: 'Learn More',
  },
  safety: {
    h2: 'Safety & Verification',
    h3: 'How to verify before buying with CSSBuy',
    description: 'Always verify links, sellers, products and costs before making payment. The CSSBuy Spreadsheet helps you organize and compare information for a safer purchase.',
    checklist1: 'Verify the product link before buying',
    checklist2: 'Check seller reviews',
    checklist3: 'Analyze QC (Quality Control) photos',
    checklist4: 'Compare shipping costs to your country',
    checklist5: 'Check active coupons and discount codes',
  },
  articles: {
    h2: 'Recent Articles & Guides',
    readMore: 'Read Article',
    article1Title: 'CSSBuy Spreadsheet: Complete Guide',
    article1Desc: 'Everything about CSSBuy Spreadsheet, how to use it, organize links and research products.',
    article2Title: 'CSSBuy Shipping Cost: What Defines the Price',
    article2Desc: 'Weight, dimensions, destination, shipping line and declared value explained.',
    article3Title: 'Is CSSBuy Legit? Practical Safety Guide',
    article3Desc: 'How to evaluate whether a product, seller or link is safe before buying.',
    article4Title: 'CSSBuy Coupon: How to Find Deals',
    article4Desc: 'Where to find active coupons, verify validity and apply discounts correctly.',
    article5Title: 'CSSBuy Warehouse Guide: Storage and Consolidation',
    article5Desc: 'How the warehouse works, storage flow, consolidation and international shipping.',
    article6Title: 'CSSBuy QC Guide: How to Read Quality Control Photos',
    article6Desc: 'What to look for in QC photos to verify quality before shipping.',
    article7Title: 'CSSBuy W2C Spreadsheet: How to Find Product Links',
    article7Desc: 'What W2C means and how to use Taobao, Weidian and 1688 links to buy.',
    article8Title: 'CSSBuy Alternatives: How to Compare Other Agents',
    article8Desc: 'Criteria for comparing CSSBuy with Superbuy, Sugargoo and other shopping agents.',
    article9Title: 'CSSBuy Shipping to Brazil: Freight to Brazil',
    article9Desc: 'Customs rules, taxes, shipping lines and consolidation for Brazil.',
    article10Title: 'CSSBuy Seller Verification: Checking Sellers',
    article10Desc: 'Signs of trustworthy sellers and warning signs to avoid bad purchases.',
    article11Title: 'CSSBuy Parcel Consolidation: Reduce Shipping',
    article11Desc: 'How to combine items into one package to save on international shipping.',
    article12Title: 'CSSBuy Beginner Handbook: Guide for Beginners',
    article12Desc: 'Everything a beginner needs to know to start buying through CSSBuy.',
    article13Title: 'CSSBuy Product Research: Find Good Products',
    article13Desc: 'How to research, compare prices and verify quality before buying.',
    article14Title: 'CSSBuy Sneakers Spreadsheet: Sneakers Guide',
    article14Desc: 'How to find sneakers, verify size, quality and price.',
  },
  faq: {
    h2: 'Frequently Asked Questions',
    q1: 'What is CSSBuy Spreadsheet?',
    a1: 'CSSBuy Spreadsheet is an organized resource with product links, categories and guides to help buyers research and find items before purchasing through the CSSBuy agent.',
    q2: 'How do I use CSSBuy Spreadsheet?',
    a2: 'Use the search bar or browse categories to find products. Click on links to verify details, seller and QC photos before adding to cart.',
    q3: 'Is CSSBuy legit?',
    a3: 'CSSBuy is a known shopping agent. This website is an independent resource to help you verify links, sellers and information before buying.',
    q4: 'Is CSSBuy safe?',
    a4: 'Safety depends on verifying links, sellers, QC photos and understanding shipping costs before paying. Use this guide to organize your research.',
    q5: 'How does CSSBuy shipping work?',
    a5: 'Shipping depends on weight, dimensions, destination, chosen shipping line and declared value. Warehouse and consolidation can reduce costs.',
    q6: 'How much does CSSBuy shipping cost?',
    a6: 'Costs vary by weight, dimensions, destination country, shipping line and insurance. See our complete shipping guide for estimates.',
    q7: 'What is CSSBuy QC?',
    a7: 'QC (Quality Control) are inspection photos of the product taken at the warehouse before shipping. They help verify if the item is correct.',
    q8: 'What is CSSBuy warehouse?',
    a8: 'The warehouse is where products are stored after purchase. Includes QC inspection, storage and consolidation before international shipping.',
    q9: 'Where can I find CSSBuy coupons?',
    a9: 'Coupons and discount codes can be found in updated guides. Always verify validity and restrictions before using.',
    q10: 'How do I verify CSSBuy discount codes?',
    a10: 'Verify the expiration date, minimum purchase value, region restrictions and whether the code is still active before applying.',
  },
  ctaBanner: {
    h2: 'Ready to explore the CSSBuy Spreadsheet?',
    description: 'Continue to the main website to find more products, links and organized resources.',
    cta: 'Continue to Main Website',
    cta2: 'Buy It Now',
  },
  footer: {
    tagline: 'Independent resource about CSSBuy Spreadsheet. We are not affiliated with or endorsed by CSSBuy.',
    links: 'Useful Links',
    legal: 'Legal',
    resources: 'Resources',
    about: 'About',
    editorial: 'Editorial Policy',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    spreadsheet: 'CSSBuy Spreadsheet',
    review: 'CSSBuy Review',
    shipping: 'Shipping',
    coupon: 'Coupon',
    warehouse: 'Warehouse',
    legit: 'Is It Safe?',
    articles: 'Articles',
    safety: 'Safety',
    copyright: 'CSSSpreadsheetBR. Independent resource. Not affiliated with CSSBuy.',
  },
  breadcrumb: {
    home: 'Home',
  },
  notFound: {
    title: 'Page not found',
    description: 'The page you are looking for does not exist. Go back to the homepage and continue exploring the CSSBuy Spreadsheet.',
    cta: 'Back to Home',
  },
  general: {
    lastUpdated: 'Updated on',
    readTime: 'min read',
    quickAnswer: 'Quick answer:',
    checklist: 'Checklist',
    relatedArticles: 'Related Articles',
    tableOfContents: 'Contents',
    share: 'Share',
    author: 'Author',
    editor: 'Editor',
    disclaimer: 'This website is an independent resource and is not affiliated with or endorsed by CSSBuy. Information is provided for research and organization purposes.',
  },
  schema: {
    organization: 'CSSSpreadsheetBR',
    organizationDesc: 'Independent resource about CSSBuy Spreadsheet, products, links and buying guides.',
    faqPage: 'Frequently Asked Questions about CSSBuy Spreadsheet',
  },
  products: {
    eyebrow: 'Explore Products',
    title: 'Featured Products',
    description: 'Browse curated products from the CSSBuy Spreadsheet. Click any item to view details and purchase on the main site.',
    viewAll: 'View All',
    buy: 'Buy',
    noProducts: 'Products coming soon',
  },
};